import { library } from "@fortawesome/fontawesome-svg-core";
import { faLink, faPowerOff, faUser, faVolumeMute, faVolumeUp } from "@fortawesome/free-solid-svg-icons";

function initFontAwesome() {
  library.add(faLink);
  library.add(faUser);
  library.add(faPowerOff);
  library.add(faVolumeUp);
  library.add(faVolumeMute);
}

export default initFontAwesome;
